import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Row,
  Col,
  PreviewCard,
  PreviewAltCard,
  Button,
  RSelect,
} from "../../../components/Component";
import { api } from "../../../utils/api";
import { toast } from "react-toastify";
import { Spinner, Badge, Modal, ModalBody, ModalHeader, Form, FormGroup, Label, Input, Input as RSInput } from "reactstrap";
import { MapContainer, TileLayer, Circle, Marker, Popup, useMap } from "react-leaflet";
import { divIcon, LatLngBounds } from "leaflet";
import "leaflet/dist/leaflet.css";
import moment from "moment";

const RiskMappingPage = () => {
  const [riskZones, setRiskZones] = useState([]);
  const [mapRiskZones, setMapRiskZones] = useState([]);
  const [mapObservations, setMapObservations] = useState([]);
  const [showObservations, setShowObservations] = useState(true);
  const [sites, setSites] = useState([]);
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mapLoading, setMapLoading] = useState(false);
  const [selectedObservation, setSelectedObservation] = useState(null);
  const [actionsModalOpen, setActionsModalOpen] = useState(false);
  const [selectedZoneForActions, setSelectedZoneForActions] = useState(null);
  const [zoneActions, setZoneActions] = useState([]);
  const [loadingActions, setLoadingActions] = useState(false);
  const [actionModalOpen, setActionModalOpen] = useState(false);
  const [editingAction, setEditingAction] = useState(null);
  const [actionFormData, setActionFormData] = useState({
    title: "",
    description: "",
    priority: "medium",
    due_date: "",
    assigned_to: "",
  });
  const [users, setUsers] = useState([]);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const response = await api.getUsers({ per_page: 100 });
      setUsers(response.data || response || []);
    } catch (error) {
      console.error("Error loading users:", error);
    }
  };
  const [modalOpen, setModalOpen] = useState(false);
  const [editingZone, setEditingZone] = useState(null);
  const [selectedZone, setSelectedZone] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [zoneToDelete, setZoneToDelete] = useState(null);
  // Congo-Brazzaville: Centre par défaut sur Brazzaville (capitale)
  const [mapCenter, setMapCenter] = useState([-4.2634, 15.2429]); // Brazzaville, Congo-Brazzaville [lat, lng]
  const [mapZoom, setMapZoom] = useState(7); // Zoom pour voir le pays entier
  const mapRef = useRef(null);

  // Filtres
  const [filters, setFilters] = useState({
    site_id: null,
    risk_level: null,
    search: "",
  });

  // Formulaire
  const [formData, setFormData] = useState({
    site_id: "",
    name: "",
    description: "",
    risk_level: "medium",
    risk_category: "",
    probability_score: 3,
    severity_score: 3,
    latitude: "",
    longitude: "",
    radius: 50,
    color: "",
    identified_date: "",
    review_date: "",
    target_resolution_date: "",
    responsible_user_id: "",
    mitigation_measures: "",
    is_active: true,
  });

  const riskLevels = [
    { value: "low", label: "Faible", color: "#28a745" },
    { value: "medium", label: "Moyen", color: "#ffc107" },
    { value: "high", label: "Élevé", color: "#fd7e14" },
    { value: "critical", label: "Critique", color: "#dc3545" },
  ];

  const riskCategories = [
    { value: "safety", label: "Sécurité" },
    { value: "health", label: "Santé" },
    { value: "environment", label: "Environnement" },
    { value: "fire", label: "Incendie/Explosion" },
    { value: "electrical", label: "Électricité" },
    { value: "chemical", label: "Chimique/Toxique" },
    { value: "mechanical", label: "Mécanique" },
    { value: "thermal", label: "Thermique" },
    { value: "radiological", label: "Radiologique" },
    { value: "biological", label: "Biologique" },
  ];

  const probabilityOptions = [
    { value: 1, label: "1 - Rare" },
    { value: 2, label: "2 - Peu probable" },
    { value: 3, label: "3 - Possible" },
    { value: 4, label: "4 - Probable" },
    { value: 5, label: "5 - Quasi certain" },
  ];

  const severityOptions = [
    { value: 1, label: "1 - Négligeable" },
    { value: 2, label: "2 - Faible" },
    { value: 3, label: "3 - Modérée" },
    { value: 4, label: "4 - Élevée" },
    { value: 5, label: "5 - Catastrophique" },
  ];

  useEffect(() => {
    loadSites();
    loadStatistics();
    loadRiskZones();
    loadMapData();
  }, []);

  useEffect(() => {
    loadRiskZones();
  }, [filters]);

  useEffect(() => {
    loadMapData();
    loadMapObservations();
  }, [filters.site_id, filters.risk_level]);

  const loadSites = async () => {
    try {
      const response = await api.getSites();
      setSites(response.data || []);
    } catch (error) {
      console.error("Erreur lors du chargement des sites:", error);
    }
  };

  const loadRiskZones = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.site_id) params.site_id = filters.site_id;
      if (filters.risk_level) params.risk_level = filters.risk_level;
      if (filters.search) params.search = filters.search;

      const response = await api.getRiskZones(params);
      setRiskZones(response.data || []);
    } catch (error) {
      toast.error("Erreur lors du chargement des zones de risques");
      console.error("Error loading risk zones:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadMapData = async () => {
    setMapLoading(true);
    try {
      const params = {};
      if (filters.site_id) params.site_id = filters.site_id;
      if (filters.risk_level) params.risk_level = filters.risk_level;

      const response = await api.getRiskZonesForMap(params);
      setMapRiskZones(response.data || []);

      // Centrer la carte sur la première zone ou le premier site
      // Si aucune zone, garder le centre par défaut sur Brazzaville
      if (response.data && response.data.length > 0) {
        const firstZone = response.data[0];
        const lat = parseFloat(firstZone.latitude);
        const lng = parseFloat(firstZone.longitude);
        // Vérifier que les coordonnées sont dans les limites du Congo-Brazzaville uniquement
        if (lat >= -5.0 && lat <= 3.7 && lng >= 11.2 && lng <= 16.0) {
          setMapCenter([lat, lng]);
          setMapZoom(12);
        }
      } else if (sites.length > 0 && sites[0].latitude && sites[0].longitude) {
        const lat = parseFloat(sites[0].latitude);
        const lng = parseFloat(sites[0].longitude);
        // Vérifier que les coordonnées sont dans les limites du Congo-Brazzaville uniquement
        if (lat >= -5.0 && lat <= 3.7 && lng >= 11.2 && lng <= 16.0) {
          setMapCenter([lat, lng]);
          setMapZoom(10);
        }
      }
    } catch (error) {
      console.error("Error loading map data:", error);
    } finally {
      setMapLoading(false);
    }
  };

  const loadMapObservations = async () => {
    try {
      const params = {};
      if (filters.site_id) params.site_id = filters.site_id;

      const response = await api.getObservationsForMap(params);
      setMapObservations(response.data || []);
    } catch (error) {
      console.error("Error loading map observations:", error);
    }
  };

  const loadStatistics = async () => {
    try {
      const data = await api.getRiskZonesStatistics();
      setStatistics(data);
    } catch (error) {
      console.error("Error loading statistics:", error);
    }
  };

  const handleOpenModal = (zone = null) => {
    if (zone) {
      setEditingZone(zone);
      setFormData({
        site_id: zone.site_id,
        name: zone.name,
        description: zone.description || "",
        risk_level: zone.risk_level,
        risk_category: zone.risk_category || "",
        probability_score: zone.probability_score || 3,
        severity_score: zone.severity_score || 3,
        latitude: zone.latitude,
        longitude: zone.longitude,
        radius: zone.radius || 50,
        color: zone.color || getDefaultColor(zone.risk_level),
        identified_date: zone.identified_date || "",
        review_date: zone.review_date || "",
        target_resolution_date: zone.target_resolution_date || "",
        responsible_user_id: zone.responsible_user_id || "",
        mitigation_measures: zone.mitigation_measures || "",
        is_active: zone.is_active !== undefined ? zone.is_active : true,
      });
    } else {
      setEditingZone(null);
      setFormData({
        site_id: "",
        name: "",
        description: "",
        risk_level: "medium",
        risk_category: "",
        probability_score: 3,
        severity_score: 3,
        latitude: "",
        longitude: "",
        radius: 50,
        color: "",
        identified_date: new Date().toISOString().split('T')[0],
        review_date: "",
        target_resolution_date: "",
        responsible_user_id: "",
        mitigation_measures: "",
        is_active: true,
      });
    }
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditingZone(null);
    setFormData({
      site_id: "",
      name: "",
      description: "",
      risk_level: "medium",
      risk_category: "",
      probability_score: 3,
      severity_score: 3,
      latitude: "",
      longitude: "",
      radius: 50,
      color: "",
      identified_date: "",
      review_date: "",
      target_resolution_date: "",
      responsible_user_id: "",
      mitigation_measures: "",
      is_active: true,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const lat = parseFloat(formData.latitude);
      const lng = parseFloat(formData.longitude);

      // Valider que les coordonnées sont dans les limites du Congo-Brazzaville uniquement
      if (lat < -5.0 || lat > 3.7 || lng < 11.2 || lng > 16.0) {
        toast.error("Les coordonnées doivent être dans les limites du Congo-Brazzaville (Latitude: -5.0° à 3.7°, Longitude: 11.2° à 16.0°)");
        return;
      }

      // Calculer le niveau de risque depuis la matrice si les scores sont fournis
      let calculatedRiskLevel = formData.risk_level;
      if (formData.probability_score && formData.severity_score) {
        const riskScore = parseInt(formData.probability_score) * parseInt(formData.severity_score);
        if (riskScore >= 20) calculatedRiskLevel = 'critical';
        else if (riskScore >= 12) calculatedRiskLevel = 'high';
        else if (riskScore >= 6) calculatedRiskLevel = 'medium';
        else calculatedRiskLevel = 'low';
      }

      const data = {
        ...formData,
        risk_level: calculatedRiskLevel,
        latitude: lat,
        longitude: lng,
        radius: parseInt(formData.radius),
        probability_score: parseInt(formData.probability_score) || 3,
        severity_score: parseInt(formData.severity_score) || 3,
      };

      // Nettoyer les champs vides
      if (!data.risk_category) delete data.risk_category;
      if (!data.identified_date) delete data.identified_date;
      if (!data.review_date) delete data.review_date;
      if (!data.target_resolution_date) delete data.target_resolution_date;
      if (!data.responsible_user_id) delete data.responsible_user_id;
      if (!data.mitigation_measures) delete data.mitigation_measures;

      if (!data.color) {
        data.color = getDefaultColor(calculatedRiskLevel);
      }

      if (editingZone) {
        await api.updateRiskZone(editingZone.id, data);
        toast.success("Zone de risque mise à jour avec succès");
      } else {
        await api.createRiskZone(data);
        toast.success("Zone de risque créée avec succès");
      }

      handleCloseModal();
      loadRiskZones();
      loadMapData();
      loadStatistics();
    } catch (error) {
      toast.error(error.response?.data?.message || "Erreur lors de la sauvegarde");
      console.error("Error saving risk zone:", error);
    }
  };

  const handleDelete = (zone) => {
    setZoneToDelete(zone);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (!zoneToDelete) return;

    try {
      await api.deleteRiskZone(zoneToDelete.id);
      toast.success("Zone de risque supprimée avec succès");
      setDeleteModal(false);
      setZoneToDelete(null);
      loadRiskZones();
      loadMapData();
      loadStatistics();
    } catch (error) {
      toast.error("Erreur lors de la suppression");
      console.error("Error deleting risk zone:", error);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModal(false);
    setZoneToDelete(null);
  };

  const handleMarkZoneReviewed = async (zone) => {
    if (!zone?.id) return;
    try {
      await api.markRiskZoneReviewed(zone.id);
      toast.success(`Zone "${zone.name}" marquée comme revue.`);
      setSelectedZone(null);
      await Promise.all([loadRiskZones(), loadMapData(), loadStatistics()]);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Erreur lors de la revue de la zone");
    }
  };

  const handleOpenActionsModal = async (zone) => {
    setSelectedZoneForActions(zone);
    setActionsModalOpen(true);
    await loadZoneActions(zone.id);
  };

  const handleCloseActionsModal = () => {
    setActionsModalOpen(false);
    setSelectedZoneForActions(null);
    setZoneActions([]);
  };

  const loadZoneActions = async (zoneId) => {
    setLoadingActions(true);
    try {
      const response = await api.getRiskZoneActions(zoneId);
      setZoneActions(response || []);
    } catch (error) {
      toast.error("Erreur lors du chargement des actions");
      console.error("Error loading actions:", error);
    } finally {
      setLoadingActions(false);
    }
  };

  const handleOpenActionModal = (action = null) => {
    if (action) {
      setEditingAction(action);
      setActionFormData({
        title: action.title,
        description: action.description,
        priority: action.priority,
        due_date: action.due_date ? new Date(action.due_date).toISOString().split('T')[0] : "",
        assigned_to: action.assigned_to || "",
      });
    } else {
      setEditingAction(null);
      setActionFormData({
        title: "",
        description: "",
        priority: "medium",
        due_date: "",
        assigned_to: "",
      });
    }
    setActionModalOpen(true);
  };

  const handleCloseActionModal = () => {
    setActionModalOpen(false);
    setEditingAction(null);
    setActionFormData({
      title: "",
      description: "",
      priority: "medium",
      due_date: "",
      assigned_to: "",
    });
  };

  const handleActionSubmit = async (e) => {
    e.preventDefault();
    if (!selectedZoneForActions) return;

    try {
      if (editingAction) {
        await api.updateRiskZoneAction(selectedZoneForActions.id, editingAction.id, actionFormData);
        toast.success("Action mise à jour avec succès");
      } else {
        await api.createRiskZoneAction(selectedZoneForActions.id, actionFormData);
        toast.success("Action créée avec succès");
      }

      handleCloseActionModal();
      await loadZoneActions(selectedZoneForActions.id);
    } catch (error) {
      toast.error(error.response?.data?.message || "Erreur lors de la sauvegarde");
      console.error("Error saving action:", error);
    }
  };

  const handleDeleteAction = async (action) => {
    if (!selectedZoneForActions) return;
    if (!window.confirm("Êtes-vous sûr de vouloir supprimer cette action ?")) return;

    try {
      await api.deleteRiskZoneAction(selectedZoneForActions.id, action.id);
      toast.success("Action supprimée avec succès");
      await loadZoneActions(selectedZoneForActions.id);
    } catch (error) {
      toast.error("Erreur lors de la suppression");
      console.error("Error deleting action:", error);
    }
  };

  const handleActionStatusChange = async (action, newStatus) => {
    if (!selectedZoneForActions) return;

    try {
      await api.updateRiskZoneAction(selectedZoneForActions.id, action.id, { status: newStatus });
      toast.success("Statut de l'action mis à jour");
      await loadZoneActions(selectedZoneForActions.id);
    } catch (error) {
      toast.error("Erreur lors de la mise à jour du statut");
      console.error("Error updating action status:", error);
    }
  };

  const getDefaultColor = (riskLevel) => {
    const level = riskLevels.find((l) => l.value === riskLevel);
    return level ? level.color : "#6c757d";
  };

  const getRiskLevelLabel = (level) => {
    const found = riskLevels.find((l) => l.value === level);
    return found ? found.label : level;
  };

  const getRiskLevelBadge = (level) => {
    const colors = {
      low: "success",
      medium: "warning",
      high: "warning",
      critical: "danger",
    };
    return colors[level] || "secondary";
  };

  // Composant pour gérer les clics sur la carte
  const MapClickHandler = () => {
    const map = useMap();
    useEffect(() => {
      const handleClick = (e) => {
        if (!editingZone && !modalOpen) {
          const { lat, lng } = e.latlng;
          // Vérifier que le clic est dans les limites du Congo-Brazzaville uniquement
          if (lat >= -5.0 && lat <= 3.7 && lng >= 11.2 && lng <= 16.0) {
            setFormData({
              ...formData,
              latitude: lat.toFixed(8),
              longitude: lng.toFixed(8),
            });
            handleOpenModal();
          } else {
            toast.warning("Veuillez sélectionner un emplacement dans les limites du Congo-Brazzaville");
          }
        }
      };
      map.on('click', handleClick);
      return () => {
        map.off('click', handleClick);
      };
    }, [map, editingZone, modalOpen]);
    return null;
  };

  // Composant pour centrer la carte
  const MapCenter = ({ center, zoom }) => {
    const map = useMap();
    useEffect(() => {
      map.setView(center, zoom);
    }, [map, center, zoom]);
    return null;
  };

  // Composant pour limiter la carte aux frontières du Congo-Brazzaville uniquement
  const MapBounds = () => {
    const map = useMap();
    useEffect(() => {
      // Frontières précises du Congo-Brazzaville (excluant le Congo-Kinshasa)
      // Nord: ~3.7°N, Sud: ~-5.0°S, Est: ~16.0°E, Ouest: ~11.2°E
      const congoBrazzavilleBounds = new LatLngBounds(
        [-5.0, 11.2], // Sud-Ouest
        [3.7, 16.0]   // Nord-Est (limité à 16.0°E pour éviter le Congo-Kinshasa)
      );
      map.setMaxBounds(congoBrazzavilleBounds);
      // Optionnel: ajuster la vue pour montrer tout le pays
      if (mapRiskZones.length === 0) {
        map.fitBounds(congoBrazzavilleBounds, { padding: [50, 50] });
      }
    }, [map]);
    return null;
  };

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleClearFilters = () => {
    setFilters({
      site_id: null,
      risk_level: null,
      search: "",
    });
  };

  const createMarkerIcon = (color) => {
    return divIcon({
      className: 'custom-marker-icon',
      html: `<div style="
        width: 16px;
        height: 16px;
        background-color: ${color};
        border: 2px solid #fff;
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      "></div>`,
      iconSize: [16, 16],
      iconAnchor: [8, 8],
    });
  };

  const createObservationIcon = (type) => {
    const colors = {
      dangerous: '#dc3545',
      near_miss: '#fd7e14',
      non_conformity: '#ffc107',
    };
    const color = colors[type] || '#6c757d';
    return divIcon({
      className: 'observation-marker-icon',
      html: `<div style="
        width: 14px;
        height: 14px;
        background-color: ${color};
        border: 2px solid #fff;
        border-radius: 3px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      "></div>`,
      iconSize: [14, 14],
      iconAnchor: [7, 7],
    });
  };

  const getObservationTypeLabel = (type) => {
    const labels = {
      dangerous: 'Dangereux',
      near_miss: 'Quasi-accident',
      non_conformity: 'Non-conformité',
    };
    return labels[type] || type;
  };

  const priorityZones = statistics?.priority_top_critical || [];
  const kpis = statistics?.kpis || {};

  return (
    <React.Fragment>
      <Head title="Cartographie des risques" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Cartographie des risques</BlockTitle>
              <BlockDes className="text-soft">
                <p>Visualisez et gérez les zones de risques sur une carte interactive du Congo-Brazzaville</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button color="primary" size="md" onClick={() => handleOpenModal()}>
                <Icon name="plus"></Icon>
                <span>Nouvelle zone</span>
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        {/* Statistiques */}
        {statistics && (
          <Block>
            <div className="row g-gs mb-3" style={{ display: 'flex', flexWrap: 'nowrap' }}>
              <div className="col" style={{ flex: '0 0 20%', maxWidth: '20%' }}>
                <div className="card border-0 bg-light">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <span className="sub-text d-block">Total Zones</span>
                        <h4 className="mb-0">{statistics.total || 0}</h4>
                      </div>
                      <Icon name="map" className="text-primary" style={{ fontSize: "2rem" }}></Icon>
                    </div>
                  </div>
                </div>
              </div>
              {riskLevels.map((level) => (
                <div key={level.value} className="col" style={{ flex: '0 0 20%', maxWidth: '20%' }}>
                  <div className="card border-0 bg-light">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <span className="sub-text d-block">{level.label}</span>
                          <h4 className="mb-0" style={{ color: level.color }}>
                            {statistics.by_level[level.value] || 0}
                          </h4>
                        </div>
                        <Icon 
                          name={level.value === "low" ? "check-circle" : level.value === "medium" ? "alert-circle" : level.value === "high" ? "alert-fill" : "alert"} 
                          style={{ fontSize: "2rem", color: level.color }}
                        ></Icon>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="row g-gs">
              <div className="col-md-4">
                <div className="card border-0 bg-light">
                  <div className="card-body">
                    <span className="sub-text d-block">Couverture risques critiques</span>
                    <h4 className="mb-0 text-primary">
                      {kpis.critical_coverage_percent != null ? `${kpis.critical_coverage_percent}%` : "0%"}
                    </h4>
                    <small className="text-soft">
                      {kpis.critical_with_plan || 0} / {kpis.critical_total || 0} avec plan d&apos;action
                    </small>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card border-0 bg-light">
                  <div className="card-body">
                    <span className="sub-text d-block">Actions en retard</span>
                    <h4 className="mb-0 text-danger">{kpis.overdue_actions || 0}</h4>
                    <small className="text-soft">Actions ouvertes hors échéance</small>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card border-0 bg-light">
                  <div className="card-body">
                    <span className="sub-text d-block">Zones sans mise à jour (30j+)</span>
                    <h4 className="mb-0 text-warning">{kpis.stale_risk_zones_30d || 0}</h4>
                    <small className="text-soft">
                      Délai moyen mitigation: {kpis.avg_mitigation_days != null ? `${kpis.avg_mitigation_days} j` : "n/d"}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </Block>
        )}

        {statistics && (
          <Block>
            <PreviewCard>
              <div className="nk-block-head">
                <h6 className="title">Top 10 zones critiques à traiter</h6>
              </div>
              {priorityZones.length === 0 ? (
                <p className="text-soft mb-0">Aucune zone critique prioritaire pour le moment.</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Zone</th>
                        <th>Site</th>
                        <th>Responsable</th>
                        <th>Score</th>
                        <th>Actions ouvertes</th>
                        <th>Retards</th>
                        <th>Dernière mise à jour</th>
                      </tr>
                    </thead>
                    <tbody>
                      {priorityZones.map((zone) => (
                        <tr key={`priority-zone-${zone.id}`}>
                          <td><strong>{zone.name}</strong></td>
                          <td>{zone.site_name || "-"}</td>
                          <td>{zone.responsible_name || "-"}</td>
                          <td>{zone.risk_score || 0}</td>
                          <td>{zone.actions_open_count || 0}</td>
                          <td>
                            <Badge color={zone.overdue_actions_count > 0 ? "danger" : "success"}>
                              {zone.overdue_actions_count || 0}
                            </Badge>
                          </td>
                          <td>
                            {zone.days_since_update != null ? `${zone.days_since_update} j` : "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </PreviewCard>
          </Block>
        )}

        {/* Filtres */}
        <Block>
          <PreviewCard>
            <div className="nk-block-head">
              <h6 className="title">Filtres</h6>
            </div>
            <Row className="g-gs">
              <Col md="4">
                <FormGroup>
                  <Label>Site</Label>
                  <RSelect
                    options={[{ value: "", label: "Tous les sites" }, ...sites.map((s) => ({ value: s.id, label: s.name }))]}
                    value={
                      filters.site_id
                        ? { value: filters.site_id, label: sites.find((s) => s.id === filters.site_id)?.name || "" }
                        : { value: "", label: "Tous les sites" }
                    }
                    onChange={(option) => handleFilterChange("site_id", option.value || null)}
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Niveau de risque</Label>
                  <RSelect
                    options={[{ value: "", label: "Tous les niveaux" }, ...riskLevels.map((l) => ({ value: l.value, label: l.label }))]}
                    value={
                      filters.risk_level
                        ? { value: filters.risk_level, label: getRiskLevelLabel(filters.risk_level) }
                        : { value: "", label: "Tous les niveaux" }
                    }
                    onChange={(option) => handleFilterChange("risk_level", option.value || null)}
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Recherche</Label>
                  <Input
                    type="text"
                    placeholder="Nom ou description..."
                    value={filters.search}
                    onChange={(e) => handleFilterChange("search", e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>
            {(filters.site_id || filters.risk_level || filters.search) && (
              <div className="mt-3">
                <Button color="light" size="sm" onClick={handleClearFilters}>
                  <Icon name="cross"></Icon>
                  <span>Effacer les filtres</span>
                </Button>
              </div>
            )}
          </PreviewCard>
        </Block>

        {/* Carte interactive */}
        <Block>
          <PreviewCard>
            <div className="nk-block-head">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="title">Carte interactive - Congo-Brazzaville</h6>
                  <p className="text-soft small mb-0">Cliquez sur la carte pour ajouter une nouvelle zone de risque (limites: Latitude -5.0° à 3.7°, Longitude 11.2° à 16.0° - Congo-Brazzaville uniquement)</p>
                </div>
                <div>
                  <Button
                    color={showObservations ? "primary" : "light"}
                    size="sm"
                    onClick={() => setShowObservations(!showObservations)}
                    className="d-flex align-items-center"
                  >
                    <Icon name={showObservations ? "eye" : "eye-off"} className="me-1"></Icon>
                    <span>{showObservations ? "Masquer observations" : "Afficher observations"}</span>
                  </Button>
                </div>
              </div>
            </div>
            <div style={{ height: "600px", width: "100%", position: "relative" }}>
              {mapLoading ? (
                <div className="d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
                  <Spinner color="primary" />
                </div>
              ) : (
                <MapContainer
                  center={mapCenter}
                  zoom={mapZoom}
                  style={{ height: "100%", width: "100%" }}
                  whenCreated={(mapInstance) => {
                    mapRef.current = mapInstance;
                  }}
                >
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  <MapBounds />
                  <MapCenter center={mapCenter} zoom={mapZoom} />
                  <MapClickHandler />
                  {mapRiskZones.map((zone) => (
                    <React.Fragment key={zone.id}>
                      <Circle
                        center={[parseFloat(zone.latitude), parseFloat(zone.longitude)]}
                        radius={zone.radius}
                        pathOptions={{
                          fillColor: zone.color,
                          fillOpacity: 0.3,
                          color: zone.color,
                          weight: 2,
                          opacity: 0.8,
                        }}
                        eventHandlers={{
                          click: () => setSelectedZone(zone),
                        }}
                      />
                      <Marker
                        position={[parseFloat(zone.latitude), parseFloat(zone.longitude)]}
                        icon={createMarkerIcon(zone.color)}
                        eventHandlers={{
                          click: () => setSelectedZone(zone),
                        }}
                      >
                        {selectedZone && selectedZone.id === zone.id && (
                          <Popup onClose={() => setSelectedZone(null)}>
                            <div style={{ padding: "5px", minWidth: "200px" }}>
                              <h6 style={{ marginBottom: "8px", fontWeight: "bold" }}>{zone.name}</h6>
                              <p style={{ marginBottom: "4px", fontSize: "12px", color: "#666" }}>
                                <Badge color={getRiskLevelBadge(zone.risk_level)}>{getRiskLevelLabel(zone.risk_level)}</Badge>
                              </p>
                              {zone.description && (
                                <p style={{ marginBottom: "4px", fontSize: "12px" }}>{zone.description}</p>
                              )}
                              {zone.site && (
                                <p style={{ marginBottom: "4px", fontSize: "12px", color: "#666" }}>
                                  <Icon name="map-pin"></Icon> {zone.site.name}
                                </p>
                              )}
                              <div className="mt-2 d-flex gap-1 flex-wrap">
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => {
                                    setSelectedZone(null);
                                    handleOpenModal(zone);
                                  }}
                                >
                                  <Icon name="edit"></Icon>
                                </Button>
                                <Button
                                  color="info"
                                  size="sm"
                                  onClick={() => {
                                    setSelectedZone(null);
                                    handleOpenActionsModal(zone);
                                  }}
                                >
                                  <Icon name="list-check"></Icon> Actions
                                </Button>
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() => handleMarkZoneReviewed(zone)}
                                >
                                  <Icon name="check-circle"></Icon>
                                </Button>
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() => {
                                    setSelectedZone(null);
                                    handleDelete(zone);
                                  }}
                                >
                                  <Icon name="trash"></Icon>
                                </Button>
                              </div>
                            </div>
                          </Popup>
                        )}
                      </Marker>
                    </React.Fragment>
                  ))}
                  {/* Marqueurs d'observations */}
                  {showObservations && mapObservations.map((observation) => (
                    <Marker
                      key={`obs-${observation.id}`}
                      position={[parseFloat(observation.location_latitude), parseFloat(observation.location_longitude)]}
                      icon={createObservationIcon(observation.type)}
                      eventHandlers={{
                        click: () => setSelectedObservation(observation),
                      }}
                    >
                      {selectedObservation && selectedObservation.id === observation.id && (
                        <Popup onClose={() => setSelectedObservation(null)}>
                          <div style={{ padding: "5px", minWidth: "200px" }}>
                            <h6 style={{ marginBottom: "8px", fontWeight: "bold" }}>{observation.title}</h6>
                            <p style={{ marginBottom: "4px", fontSize: "12px", color: "#666" }}>
                              <Badge color={observation.type === 'dangerous' ? 'danger' : observation.type === 'near_miss' ? 'warning' : 'info'}>
                                {getObservationTypeLabel(observation.type)}
                              </Badge>
                            </p>
                            {observation.description && (
                              <p style={{ marginBottom: "4px", fontSize: "12px" }}>{observation.description.substring(0, 100)}...</p>
                            )}
                            {observation.creator && (
                              <p style={{ marginBottom: "4px", fontSize: "12px", color: "#666" }}>
                                <Icon name="user"></Icon> {observation.creator.name || observation.creator.email}
                              </p>
                            )}
                            {observation.site && (
                              <p style={{ marginBottom: "4px", fontSize: "12px", color: "#666" }}>
                                <Icon name="map-pin"></Icon> {observation.site.name}
                              </p>
                            )}
                            {moment(observation.created_at).format("DD/MM/YYYY HH:mm")}
                          </div>
                        </Popup>
                      )}
                    </Marker>
                  ))}
                </MapContainer>
              )}
            </div>
          </PreviewCard>
        </Block>

        {/* Liste des zones */}
        <Block>
          <PreviewCard>
            <div className="nk-block-head">
              <h6 className="title">Liste des zones de risques</h6>
            </div>
            {loading ? (
              <div className="text-center p-4">
                <Spinner color="primary" />
                <p className="mt-2 text-soft">Chargement...</p>
              </div>
            ) : riskZones.length === 0 ? (
              <div className="text-center p-5">
                <Icon name="map" size="3x" className="text-muted mb-3"></Icon>
                <p className="text-soft">Aucune zone de risque trouvée</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Nom</th>
                      <th>Site</th>
                      <th>Niveau</th>
                      <th>Score</th>
                      <th>Actions ouvertes</th>
                      <th>Actions en retard</th>
                      <th>Mise à jour</th>
                      <th>Position</th>
                      <th>Rayon</th>
                      <th>Créé le</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {riskZones.map((zone) => (
                      <tr key={zone.id}>
                        <td>
                          <strong>{zone.name}</strong>
                          {zone.description && (
                            <p className="text-soft small mb-0 mt-1">{zone.description}</p>
                          )}
                        </td>
                        <td>{zone.site?.name || "-"}</td>
                        <td>
                          <Badge color={getRiskLevelBadge(zone.risk_level)}>{getRiskLevelLabel(zone.risk_level)}</Badge>
                        </td>
                        <td>{zone.risk_score || 0}</td>
                        <td>{zone.actions_open_count || 0}</td>
                        <td>
                          <Badge color={(zone.overdue_actions_count || 0) > 0 ? "danger" : "success"}>
                            {zone.overdue_actions_count || 0}
                          </Badge>
                        </td>
                        <td>
                          {zone.days_since_update != null ? `${zone.days_since_update} j` : "-"}
                          {(zone.days_since_update || 0) >= 30 && (
                            <Badge color="warning" className="ms-1">Sans MAJ</Badge>
                          )}
                        </td>
                        <td>
                          <small>
                            {parseFloat(zone.latitude).toFixed(6)}, {parseFloat(zone.longitude).toFixed(6)}
                          </small>
                        </td>
                        <td>{zone.radius}m</td>
                        <td>{moment(zone.created_at).format("DD/MM/YYYY")}</td>
                        <td>
                          <Button
                            color="primary"
                            size="sm"
                            className="me-1"
                            onClick={() => {
                              setMapCenter([parseFloat(zone.latitude), parseFloat(zone.longitude)]);
                              setMapZoom(15);
                              setSelectedZone(zone);
                            }}
                          >
                            <Icon name="map-pin"></Icon>
                          </Button>
                          <Button color="primary" size="sm" className="me-1" onClick={() => handleOpenModal(zone)}>
                            <Icon name="edit"></Icon>
                          </Button>
                          <Button color="info" size="sm" className="me-1" onClick={() => handleOpenActionsModal(zone)}>
                            <Icon name="list-check"></Icon>
                          </Button>
                          <Button color="success" size="sm" className="me-1" onClick={() => handleMarkZoneReviewed(zone)}>
                            <Icon name="check-circle"></Icon>
                          </Button>
                          <Button color="danger" size="sm" onClick={() => handleDelete(zone)}>
                            <Icon name="trash"></Icon>
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </PreviewCard>
        </Block>

        {/* Modal de création/édition */}
        <Modal isOpen={modalOpen} toggle={handleCloseModal} size="lg">
          <ModalHeader toggle={handleCloseModal}>
            {editingZone ? "Modifier la zone de risque" : "Nouvelle zone de risque"}
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>
                      Site <span className="text-danger">*</span>
                    </Label>
                    <RSelect
                      options={sites.map((s) => ({ value: s.id, label: s.name }))}
                      value={formData.site_id ? { value: formData.site_id, label: sites.find((s) => s.id === formData.site_id)?.name || "" } : null}
                      onChange={(option) => setFormData({ ...formData, site_id: option.value })}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>
                      Nom <span className="text-danger">*</span>
                    </Label>
                    <RSInput
                      type="text"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>Description</Label>
                    <RSInput
                      type="textarea"
                      rows="3"
                      value={formData.description}
                      onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>
                      Catégorie de risque
                    </Label>
                    <RSelect
                      options={[{ value: "", label: "Sélectionner..." }, ...riskCategories.map((c) => ({ value: c.value, label: c.label }))]}
                      value={formData.risk_category ? { value: formData.risk_category, label: riskCategories.find((c) => c.value === formData.risk_category)?.label || "" } : { value: "", label: "Sélectionner..." }}
                      onChange={(option) => setFormData({ ...formData, risk_category: option.value || "" })}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>
                      Niveau de risque calculé
                    </Label>
                    <div className="form-control" style={{ padding: "0.5rem", backgroundColor: "#f8f9fa" }}>
                      <Badge color={getRiskLevelBadge(formData.risk_level)} style={{ fontSize: "0.9rem" }}>
                        {getRiskLevelLabel(formData.risk_level)}
                        {formData.probability_score && formData.severity_score && (
                          <span className="ms-2">(Score: {formData.probability_score} × {formData.severity_score} = {formData.probability_score * formData.severity_score})</span>
                        )}
                      </Badge>
                    </div>
                    <small className="text-muted">Calculé automatiquement depuis la matrice de risque</small>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>
                      Probabilité <span className="text-danger">*</span>
                    </Label>
                    <RSelect
                      options={probabilityOptions.map((p) => ({ value: p.value, label: p.label }))}
                      value={{ value: formData.probability_score, label: probabilityOptions.find((p) => p.value === formData.probability_score)?.label || "" }}
                      onChange={(option) => {
                        const newProb = option.value;
                        const riskScore = newProb * formData.severity_score;
                        let newLevel = 'low';
                        if (riskScore >= 20) newLevel = 'critical';
                        else if (riskScore >= 12) newLevel = 'high';
                        else if (riskScore >= 6) newLevel = 'medium';
                        setFormData({
                          ...formData,
                          probability_score: newProb,
                          risk_level: newLevel,
                          color: getDefaultColor(newLevel),
                        });
                      }}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>
                      Gravité <span className="text-danger">*</span>
                    </Label>
                    <RSelect
                      options={severityOptions.map((s) => ({ value: s.value, label: s.label }))}
                      value={{ value: formData.severity_score, label: severityOptions.find((s) => s.value === formData.severity_score)?.label || "" }}
                      onChange={(option) => {
                        const newSev = option.value;
                        const riskScore = formData.probability_score * newSev;
                        let newLevel = 'low';
                        if (riskScore >= 20) newLevel = 'critical';
                        else if (riskScore >= 12) newLevel = 'high';
                        else if (riskScore >= 6) newLevel = 'medium';
                        setFormData({
                          ...formData,
                          severity_score: newSev,
                          risk_level: newLevel,
                          color: getDefaultColor(newLevel),
                        });
                      }}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>
                      Latitude <span className="text-danger">*</span>
                    </Label>
                    <RSInput
                      type="number"
                      step="any"
                      value={formData.latitude}
                      onChange={(e) => setFormData({ ...formData, latitude: e.target.value })}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>
                      Longitude <span className="text-danger">*</span>
                    </Label>
                    <RSInput
                      type="number"
                      step="any"
                      value={formData.longitude}
                      onChange={(e) => setFormData({ ...formData, longitude: e.target.value })}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Rayon (mètres)</Label>
                    <RSInput
                      type="number"
                      min="10"
                      max="10000"
                      value={formData.radius}
                      onChange={(e) => setFormData({ ...formData, radius: parseInt(e.target.value) || 50 })}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Couleur</Label>
                    <div className="d-flex align-items-center">
                      <RSInput
                        type="color"
                        value={formData.color || getDefaultColor(formData.risk_level)}
                        onChange={(e) => setFormData({ ...formData, color: e.target.value })}
                        style={{ width: "60px", marginRight: "10px" }}
                      />
                      <RSInput
                        type="text"
                        value={formData.color || getDefaultColor(formData.risk_level)}
                        onChange={(e) => setFormData({ ...formData, color: e.target.value })}
                        placeholder="#000000"
                      />
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <div className="mt-4 d-flex justify-content-end">
                <Button color="light" className="me-2" onClick={handleCloseModal}>
                  Annuler
                </Button>
                <Button color="primary" type="submit">
                  {editingZone ? "Mettre à jour" : "Créer"}
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        {/* Modal de gestion des actions */}
        <Modal isOpen={actionsModalOpen} toggle={handleCloseActionsModal} size="lg">
          <ModalHeader toggle={handleCloseActionsModal}>
            Plans d'action - {selectedZoneForActions?.name}
          </ModalHeader>
          <ModalBody>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <p className="text-soft mb-0">Gérez les actions correctives pour cette zone de risque</p>
              <Button color="primary" size="sm" onClick={() => handleOpenActionModal(null)}>
                <Icon name="plus"></Icon>
                <span>Nouvelle action</span>
              </Button>
            </div>

            {loadingActions ? (
              <div className="text-center p-4">
                <Spinner color="primary" />
                <p className="mt-2 text-soft">Chargement...</p>
              </div>
            ) : zoneActions.length === 0 ? (
              <div className="text-center p-5">
                <Icon name="list-check" size="3x" className="text-muted mb-3"></Icon>
                <p className="text-soft">Aucune action définie</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Titre</th>
                      <th>Priorité</th>
                      <th>Statut</th>
                      <th>Assigné à</th>
                      <th>Date limite</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {zoneActions.map((action) => (
                      <tr key={action.id}>
                        <td>
                          <strong>{action.title}</strong>
                          {action.description && (
                            <p className="text-soft small mb-0 mt-1">{action.description.substring(0, 100)}...</p>
                          )}
                        </td>
                        <td>
                          <Badge
                            color={
                              action.priority === 'critical' ? 'danger' :
                              action.priority === 'high' ? 'warning' :
                              action.priority === 'medium' ? 'info' : 'secondary'
                            }
                          >
                            {action.priority}
                          </Badge>
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <Badge
                              color={
                                action.status === 'verified' ? 'success' :
                                action.status === 'completed' ? 'primary' :
                                action.status === 'in_progress' ? 'info' : 'secondary'
                              }
                            >
                              {action.status === 'todo' ? 'À faire' :
                               action.status === 'in_progress' ? 'En cours' :
                               action.status === 'completed' ? 'Terminé' : 'Vérifié'}
                            </Badge>
                            <RSelect
                              options={[
                                { value: 'todo', label: 'À faire' },
                                { value: 'in_progress', label: 'En cours' },
                                { value: 'completed', label: 'Terminé' },
                                { value: 'verified', label: 'Vérifié' },
                              ]}
                              value={{
                                value: action.status,
                                label: action.status === 'todo' ? 'À faire' :
                                       action.status === 'in_progress' ? 'En cours' :
                                       action.status === 'completed' ? 'Terminé' : 'Vérifié'
                              }}
                              onChange={(option) => handleActionStatusChange(action, option.value)}
                              isSearchable={false}
                              className="status-select"
                              styles={{ control: (base) => ({ ...base, minHeight: '28px', height: '28px' }) }}
                            />
                          </div>
                        </td>
                        <td>{action.assignee ? (action.assignee.first_name + ' ' + action.assignee.last_name) : '-'}</td>
                        <td>
                          {action.due_date ? moment(action.due_date).format("DD/MM/YYYY") : '-'}
                          {action.due_date && moment(action.due_date).isBefore(moment()) && action.status !== 'completed' && action.status !== 'verified' && (
                            <Badge color="danger" className="ms-2">En retard</Badge>
                          )}
                        </td>
                        <td>
                          <Button color="primary" size="sm" className="me-1" onClick={() => handleOpenActionModal(action)}>
                            <Icon name="edit"></Icon>
                          </Button>
                          <Button color="danger" size="sm" onClick={() => handleDeleteAction(action)}>
                            <Icon name="trash"></Icon>
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </ModalBody>
        </Modal>

        {/* Modal de création/édition d'action */}
        <Modal isOpen={actionModalOpen} toggle={handleCloseActionModal} size="lg">
          <ModalHeader toggle={handleCloseActionModal}>
            {editingAction ? "Modifier l'action" : "Nouvelle action"}
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleActionSubmit}>
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>
                      Titre <span className="text-danger">*</span>
                    </Label>
                    <RSInput
                      type="text"
                      value={actionFormData.title}
                      onChange={(e) => setActionFormData({ ...actionFormData, title: e.target.value })}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>
                      Description <span className="text-danger">*</span>
                    </Label>
                    <RSInput
                      type="textarea"
                      rows="4"
                      value={actionFormData.description}
                      onChange={(e) => setActionFormData({ ...actionFormData, description: e.target.value })}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>
                      Priorité <span className="text-danger">*</span>
                    </Label>
                    <RSelect
                      options={[
                        { value: 'low', label: 'Faible' },
                        { value: 'medium', label: 'Moyenne' },
                        { value: 'high', label: 'Élevée' },
                        { value: 'critical', label: 'Critique' },
                      ]}
                      value={{
                        value: actionFormData.priority,
                        label: actionFormData.priority === 'low' ? 'Faible' :
                               actionFormData.priority === 'medium' ? 'Moyenne' :
                               actionFormData.priority === 'high' ? 'Élevée' : 'Critique'
                      }}
                      onChange={(option) => setActionFormData({ ...actionFormData, priority: option.value })}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>
                      Date limite <span className="text-danger">*</span>
                    </Label>
                    <RSInput
                      type="date"
                      value={actionFormData.due_date}
                      onChange={(e) => setActionFormData({ ...actionFormData, due_date: e.target.value })}
                      min={new Date().toISOString().split('T')[0]}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>Assigné à</Label>
                    <RSelect
                      options={[{ value: "", label: "Non assigné" }, ...users.map((u) => ({ value: u.id, label: `${u.first_name || ''} ${u.last_name || ''} (${u.email})`.trim() }))]}
                      value={actionFormData.assigned_to ? { value: actionFormData.assigned_to, label: users.find((u) => u.id === actionFormData.assigned_to) ? `${users.find((u) => u.id === actionFormData.assigned_to).first_name || ''} ${users.find((u) => u.id === actionFormData.assigned_to).last_name || ''} (${users.find((u) => u.id === actionFormData.assigned_to).email})`.trim() : "" } : { value: "", label: "Non assigné" }}
                      onChange={(option) => setActionFormData({ ...actionFormData, assigned_to: option.value || "" })}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className="mt-4 d-flex justify-content-end">
                <Button color="light" className="me-2" onClick={handleCloseActionModal}>
                  Annuler
                </Button>
                <Button color="primary" type="submit">
                  {editingAction ? "Mettre à jour" : "Créer"}
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        {/* Modal de confirmation de suppression */}
        <Modal isOpen={deleteModal} toggle={handleDeleteCancel} className="modal-dialog-centered">
          <div className="modal-header">
            <h5 className="modal-title">Confirmer la suppression</h5>
            <button className="close" onClick={handleDeleteCancel}>
              <Icon name="cross"></Icon>
            </button>
          </div>
          <ModalBody>
            {zoneToDelete && (
              <div className="text-center">
                <div className="mb-3">
                  <Icon name="alert-circle" className="text-danger" style={{ fontSize: "48px" }}></Icon>
                </div>
                <h6 className="mb-3">
                  Êtes-vous sûr de vouloir supprimer la zone de risque <strong>"{zoneToDelete.name}"</strong> ?
                </h6>
                <p className="text-soft small mb-2">
                  Cette action est irréversible. La zone de risque sera définitivement supprimée de la carte.
                </p>
                {zoneToDelete.site && (
                  <p className="text-soft small mb-0">
                    <Icon name="map-pin" className="me-1"></Icon>
                    Site: <strong>{zoneToDelete.site.name}</strong>
                  </p>
                )}
                <div className="mt-3">
                  <Badge color={getRiskLevelBadge(zoneToDelete.risk_level)} className="me-2">
                    Niveau: {getRiskLevelLabel(zoneToDelete.risk_level)}
                  </Badge>
                </div>
              </div>
            )}
            <div className="text-end mt-4">
              <Button color="light" onClick={handleDeleteCancel} className="me-2">
                Annuler
              </Button>
              <Button color="danger" onClick={handleDeleteConfirm}>
                <Icon name="trash" className="me-1"></Icon>
                Supprimer
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default RiskMappingPage;
